"use strict";

var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/objectSpread2.js"));
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.slice.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.map.js");
require("core-js/modules/es.object.freeze.js");
require("core-js/modules/es.object.to-string.js");
var _mixins = _interopRequireDefault(require("./mixins"));
// eslint-disable-next-line no-underscore-dangle
var _this;
var _default = exports.default = {
  name: 'wl-dialog-form',
  mixins: _mixins.default,
  data: function data() {
    _this = this;
    return {
      openDialog: false,
      ModelOriginal: {},
      slots: {
        tbas: {}
      },
      status: {
        inComputedTabsPane: false
      },
      btn: ''
      // asd: true
    };
  },
  directives: {
    'tabs-br-drag': function tabsBrDrag(el) {
      var cancel = function cancel() {
        el.onmousemove = null;
        el.onmouseup = null;
      };
      el.onmousedown = function (e0) {
        var _this$$refs$formTabs, _this$$refs$formTabs2;
        var oy = e0.clientY;
        var a0 = _this.$refs['form-tabs-container'];
        var at = (_this$$refs$formTabs = _this.$refs['form-tabs-t'][0]) === null || _this$$refs$formTabs === void 0 ? void 0 : _this$$refs$formTabs.$el;
        var ab = (_this$$refs$formTabs2 = _this.$refs['form-tabs-b'][0]) === null || _this$$refs$formTabs2 === void 0 ? void 0 : _this$$refs$formTabs2.$el;
        var h = _this.$$getDomSize(a0, 'height') - _this.$$getDomSize(ab, 'height');
        var hMin = _this.$$getDomSize(at.querySelector('.el-tabs__header'), 'height') + 60;
        var hMax = _this.$$getDomSize(a0, 'height') - (_this.$$getDomSize(ab.querySelector('.el-tabs__header'), 'height') + 60);
        at.style.cssText += ";flex: unset;flex-basis: ".concat(h, "px;");
        el.onmousemove = function (e1) {
          var ny = e1.clientY;
          var y = ny - oy;
          try {
            if (hMin < h + y & h + y < hMax) at.style.cssText += ";flex-basis: ".concat(h + y, "px;");else cancel();
          } catch (err) {
            console.warn(err);
          }
        };
        el.onmouseup = cancel;
        el.onmouseleave = cancel;
      };
    }
  },
  computed: {
    getOpenType: function getOpenType() {
      return this.$attrs.openType || this.$parent.openType;
    },
    computedBtns: function computedBtns() {
      return this.btns.map(function (btn) {
        var _btn$label, _btn$label2, _btn$label3, _btn$label4, _btn$label5, _btn$label6, _btn$label7, _btn$label8, _btn$label9, _ref, _btn$title;
        // btn.type ??= btn.code

        /** 预设
          * [ save 保存, submit 提交, approve 审核, unapprove 弃审 ]
          *  */
        switch (btn.code) {
          case 'save':
            (_btn$label = btn.label) !== null && _btn$label !== void 0 ? _btn$label : btn.label = '保存';
            break;
          case 'submit':
            (_btn$label2 = btn.label) !== null && _btn$label2 !== void 0 ? _btn$label2 : btn.label = '提交';
            break;
          case 'agree':
            (_btn$label3 = btn.label) !== null && _btn$label3 !== void 0 ? _btn$label3 : btn.label = '同意';
            break;
          case 'reject':
            (_btn$label4 = btn.label) !== null && _btn$label4 !== void 0 ? _btn$label4 : btn.label = '驳回';
            break;
          case 'return':
            (_btn$label5 = btn.label) !== null && _btn$label5 !== void 0 ? _btn$label5 : btn.label = '退回';
            break;
          case 'flow':
            (_btn$label6 = btn.label) !== null && _btn$label6 !== void 0 ? _btn$label6 : btn.label = '流程';
            break;
          case 'jmPrint':
          case 'JmPrint':
          case 'jm-print':
            (_btn$label7 = btn.label) !== null && _btn$label7 !== void 0 ? _btn$label7 : btn.label = '打印';
            break;
          case 'delete':
            (_btn$label8 = btn.label) !== null && _btn$label8 !== void 0 ? _btn$label8 : btn.label = '删除';
            break;
          default:
            break;
        }
        (_btn$label9 = btn.label) !== null && _btn$label9 !== void 0 ? _btn$label9 : btn.label = (_ref = (_btn$title = btn.title) !== null && _btn$title !== void 0 ? _btn$title : btn.name) !== null && _ref !== void 0 ? _ref : btn.code;
        return btn;
      });
    },
    isFormDisbled: function isFormDisbled() {
      return this.$$isDisabled(this.disabled) || !!(this.$parent.openType && this.$parent.openType === 'view');
    },
    isOkBtnShow: function isOkBtnShow() {
      var a = this.getOpenType !== 'view';
      var b = this.okBtn !== null;
      return a && b;
    }
  },
  /* 数据监听 */
  watch: {
    open: {
      handler: function handler(nv) {
        this.openDialog = nv;
      }
    },
    openDialog: {
      handler: function handler(nv) {
        var _this2 = this;
        this.$emit('update:open', nv);
        if (nv) {
          this.$$listenersEmit('open-dialog');
          this.$nextTick(function () {
            var _this2$$refs$wlDialo;
            (_this2$$refs$wlDialo = _this2.$refs['wl-dialog-form']) === null || _this2$$refs$wlDialo === void 0 || _this2$$refs$wlDialo.clearValidate();
            _this2.getDatas();
          });
        } else {
          var _this$$refs$wlDialog;
          (_this$$refs$wlDialog = this.$refs['wl-dialog-form']) === null || _this$$refs$wlDialog === void 0 || _this$$refs$wlDialog.resetFields();

          // eslint-disable-next-line no-unused-vars
          for (var key in this.model) {
            switch (this.$$dataTypeOf(this.model)) {
              case 'string':
                this.model[key] = '';
                break;
              case 'number':
                this.model[key] = null;
                break;
              case 'array':
                this.model[key] = [];
                break;
              default:
                // eslint-disable-next-line no-undefined
                this.model[key] = undefined;
                break;
            }
          }
          Object.assign(this.model, this.ModelOriginal);
          this.$nextTick(function () {
            var dom = _this2.$el.querySelector('.el-dialog');
            if (_this2.$attrs.width) (dom === null || dom === void 0 ? void 0 : dom.style) && (dom.style.cssText = ";width: ".concat(_this2.$attrs.width, ";"));else dom.style.cssText = '';
          });
          this.$$listenersEmit('close-dialog');
        }
      }
    }
  },
  filters: {
    /** 转换文字
      * @description: 将弹出层的打开类型转换成相应的文字，如果没有匹配，那就原样返回
      * @param { String } openType 类型
      * @return { String } 相应的文字
      */
    typeToText: function typeToText() {
      var a = arguments[0];
      switch (a) {
        case 'add':
          return ' - 新增';
        case 'view':
          return ' - 查看';
        case 'edit':
          return ' - 编辑';
        default:
          return '';
      }
    },
    /** 设置 dialog 对话框的标题文字
      * @description: 设置 dialog 对话框的标题文字，如果没有文字，则返回空
      * @param { String } title 标题
      * @return { void }
      */
    setDialogTitle: function setDialogTitle() {
      var a = arguments[0];
      return a !== null && a !== void 0 ? a : '对话框';
    }
  },
  methods: {
    init: function init() {
      if (this.openDialog !== this.open) this.openDialog = this.open;
      Object.assign(this.ModelOriginal, this.model);
      Object.freeze(this.ModelOriginal);
    },
    /** 获取 栅格
     * @return { Object } 栅格控制对象
     */
    getConfig: function getConfig() {
      return {
        grid: this.grid,
        rules: this.rules,
        form: this.model,
        width: this.$el.clientWidth
      };
    },
    onOk: function onOk() {
      // console.log('wl-dialog-form')
      this.$$listenersEmit.apply(this, ['onOk'].concat(Array.prototype.slice.call(arguments)));
      this.$$listenersEmit.apply(this, ['ok-dialog'].concat(Array.prototype.slice.call(arguments)));
    },
    onClose: function onClose() {
      this.openDialog = false;
      this.$$listenersEmit.apply(this, ['onClose'].concat(Array.prototype.slice.call(arguments)));
      this.$$listenersEmit.apply(this, ['close-dialog'].concat(Array.prototype.slice.call(arguments)));
    },
    /** 校验表单
     * @param { Function } fun 回调函数
     * @param { Function } fun1 原始回调函数
     * @return { void }
     */
    validate: function validate(fun, fun1) {
      var _this3 = this;
      this.$$debounce(function () {
        _this3.$$formValidate('wl-dialog-form', function (valid, o) {
          typeof fun === 'function' && fun(valid, o);
        }, fun1);
      });
    },
    /** 表单按钮点击事件
     * @description: 表单按钮点击事件
     * @param { Object } btn 被点击按钮设置参数对象
     * @param { Object } e 鼠标点击事件
     * @return { void }
     */
    formBtnsOnClick: function formBtnsOnClick(btn, e) {
      this.$$debounce(function () {
        var _ref2, _btn$click;
        var click = (_ref2 = (_btn$click = btn.click) !== null && _btn$click !== void 0 ? _btn$click : btn.onclick) !== null && _ref2 !== void 0 ? _ref2 : btn.onClick;
        typeof click === 'function' && click(btn, e);
      });
    } // setDialog
  },
  created: function created() {
    this.init();
    Object.assign(this.slots, (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.$slots), this.$scopedSlots));
  },
  updated: function updated() {
    this.updateTabsPane();
  }
};